import clsx from 'clsx';
import styles from 'components/UI/V3/Drawer/Footer/DrawerFooter.module.scss';
import React from 'react';

interface DrawerFooterProps {
    sticky?: boolean;
    className?: string;
    children?: React.ReactNode;
}

export const DrawerFooter: React.FC<DrawerFooterProps> = ({ children, sticky = true, className }) => {
    return <div className={clsx(styles.root, className, { [styles.sticky]: sticky })}>{children}</div>;
};
